import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import CadastroPergunta from './View/cadastro_pergunta';
import QRCodeGenerator from './View/qrcode';
import { MyProvider } from './Context';
import { ErrorBox } from './Component/error';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MyProvider>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<ErrorBox />} />
          <Route path="/qrcode/:cnes/:tipo" element={<QRCodeGenerator />} />
          <Route path="/:cnes/:tipo?" element={<App key={window.location.pathname} />} />
          <Route path="/cadastro_pergunta" element={<CadastroPergunta />} />
          <Route path="*" element={<ErrorBox />} />
        </Routes>
      </BrowserRouter>
    </MyProvider>
  </React.StrictMode>
);
